import {
  CONTRACTS_LOAD_REQUEST,
  CONTRACTS_LOAD_SUCCESS,
  CONTRACTS_LOAD_FAILURE
} from '../types/contracts-types';

const initialState = {
  loading: false,
  error: null,
  contracts: []
};

function contracts(state = initialState, action: any = null) {
  switch (action.type) {
    case CONTRACTS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CONTRACTS_LOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case CONTRACTS_LOAD_SUCCESS:
      return {
        ...state,
        contracts: action.payload,
        loading: false,
        error: null
      };

    default:
      return state;
  }
}

export default contracts;
